import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import jquery from 'jquery';
import 'summernote/dist/summernote-lite.min.js';
import 'summernote/dist/summernote-lite.min.css';
import 'summernote/dist/lang/summernote-ko-KR';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getMAGAG020, postMAGAG020, putMAGAG020 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_CENTER, MESSAGE } from '../../../shared/constants/app';
import { handleFocus } from '../../../utils';

const MAGAG020 = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const editorRef = useRef(null);

    useEffect(() => {
        jquery(editorRef.current).summernote({
            height: 300,
            lang: 'ko-KR',
            placeholder: '내용을 입력하세요...',
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'video']],
                ['view', ['codeview']],
            ],
        });
    }, []);

    const [data, setData] = useState({
        title: '',
        contentFile: '',
        dspYN: 'N',
        visitedCnt: 0,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    useEffect(() => {
        if (id) {
            getMAGAG020(id)
                .then(({ data }) => {
                    setData({
                        title: data.title || '',
                        contentFile: data.contentFile || '',
                        dspYN: data.dspYN || '',
                    });
                    if (editorRef.current) {
                        jquery(editorRef.current).summernote('code', data.contentFile);
                    }
                })
                .catch((error) => console.log(error));
        }
    }, [id]);

    const handleSave = () => {
        if (!data.title.trim()) {
            window.alert('제목을 입력해 주세요.');
            handleFocus('title');
            return;
        }
        const content = jquery(editorRef.current).summernote('code').trim();
        if (!content || content === '<p><br></p>') {
            window.alert('내용을 입력해 주세요.');
            return;
        }

        if (id) {
            if (window.confirm('등록/수정하시겠습니까?')) {
                putMAGAG020({
                    seq: id,
                    title: data?.title || '',
                    contentFile: jquery(editorRef.current).summernote('code'),
                    dspYN: data?.dspYN,
                })
                    .then(() => {
                        window.alert('등록/수정되었습니다.');
                        navigate('/magag010');
                    })
                    .catch((error) => {
                        console.log(error);
                        window.alert(MESSAGE.code[error.status]);
                    });
            }
        } else {
            if (window.confirm('등록/수정하시겠습니까?')) {
                postMAGAG020({
                    title: data?.title || '',
                    contentFile: jquery(editorRef.current).summernote('code'),
                    visitedCnt: 0,
                    addDate: moment().format('YYYY-MM-DDTHH:mm:ss.SSS'),
                    dspYN: data?.dspYN,
                })
                    .then(() => {
                        window.alert('등록/수정되었습니다.');
                        navigate('/magag010');
                    })
                    .catch((error) => {
                        console.log(error);
                        window.alert(MESSAGE.code[error.status]);
                    });
            }
        }
    };

    return (
        <div className="container dental-magazine">
            <div className="wrap">
                <SideMenu menu={MENU_CENTER} />
                <div className="add-faq-content content-right">
                    {!id ? (
                        <h1 className="title">자주 묻는 질문 등록</h1>
                    ) : (
                        <h1 className="title">자주 묻는 질문 수정</h1>
                    )}
                    <div id="add-faq-content-list">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th className="required">
                                        <span>제목</span>
                                    </th>
                                    <td colSpan={3}>
                                        <input
                                            type="text"
                                            name="title"
                                            placeholder="제목 입력"
                                            value={data?.title}
                                            onChange={handleChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th className="required">
                                        <span>내용</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div style={{ height: '300px' }} ref={editorRef}></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>공개여부</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="select-box">
                                            <select name="dspYN" value={data?.dspYN} onChange={handleChange}>
                                                <option value="N">비공개</option>
                                                <option value="Y">공개</option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="bottom-content">
                        <Link to={'/magag010'} className="button-back-to-list">
                            목록
                        </Link>
                        <Link className="button-save" onClick={handleSave}>
                            등록/수정
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MAGAG020;
